import { observer } from "mobx-react";
import { useStores } from "hooks/useStores";
import {SmallView, Text1, View} from "../../../../styles/business-components";
import {Button, Variant} from "../../../Button";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt14_img1.png'

export const Content14 = observer(() => {

  const { businessStore } = useStores()

  return (
    <S.CustomContainer>
        <View>
            <S.Content>
                <S.ImageBlock>
                    <S.Image src={Image}/>
                </S.ImageBlock>
                <S.TextBlock>
                    <S.LTitle>СКИДКА 10% ДЛЯ БИЗНЕС-ПАРТНЕРОВ</S.LTitle>
                    <Text1>
                        TeleGuard для бизнеса будет доступен осенью 2023 года. Для наших бизнес-партнеров мы делаем
                        единовременное предложение с ранней скидкой в размере 10%. Зарегистрируйтесь и мы сообщим вам
                        о запуске версии TeleGuard для бизнеса и подарим скидку 10%.
                    </Text1>
                    <div>
                        <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}>ПРИСОЕДИНИТЬСЯ СЕЙЧАС</Button>
                        <S.Note>Цены без учета НДС на одного пользователя и год</S.Note>
                    </div>
                </S.TextBlock>
            </S.Content>
        </View>
        <SmallView>
            <S.SmallContent>
                <S.LTitle>СКИДКА 10% ДЛЯ БИЗНЕС-ПАРТНЕРОВ</S.LTitle>

                <S.ImageBlock>
                    <S.Image src={Image}/>
                </S.ImageBlock>

                <S.Text>
                    TeleGuard для бизнеса будет доступен осенью 2023 года. Для наших бизнес-партнеров мы делаем
                    единовременное предложение с ранней скидкой в размере 10%. Зарегистрируйтесь и мы сообщим вам
                    о запуске версии TeleGuard для бизнеса и подарим скидку 10%.
                </S.Text>
                <div>
                    <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}>ПРИСОЕДИНИТЬСЯ СЕЙЧАС</Button>
                </div>
                <div><S.Note>Цены без учета НДС на одного пользователя и год</S.Note></div>
            </S.SmallContent>
        </SmallView>
    </S.CustomContainer>
  )
})